import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";

const styles = StyleSheet.create({
  page: {
    paddingTop: 20,
    paddingHorizontal: 20,
    paddingBottom: 48,
    fontSize: 6,
    flexDirection: "column",
    position: "relative",
    color: "#252525",
    flex: 1,
  },

  logoContainer: {
    marginBottom: 6,
  },

  logo: {
    width: 120,
  },

  titleContainer: {
    alignItems: "center",
    marginBottom: 15,
  },

  titleText: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    color: "#328AC4",
  },

  orderText: {
    fontSize: 8,
    color: "#666666",
    marginTop: 3,
  },

  sectionTitle: {
    marginTop: 5,
    marginBottom: 4,
    paddingBottom: 2,
    borderBottom: "0.7pt solid #328AC4",
  },

  subTitle: {
    fontSize: 9,
    fontWeight: "bold",
    color: "#328AC4",
  },

  table: {
    marginBottom: 9,
    border: "0.7pt solid #D5DCE3",
    borderRadius: 3,
    overflow: "hidden",
  },

  tableHeader: {
    backgroundColor: "#EEF3F7",
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottom: "0.5pt solid #D5DCE3",
  },

  tableRow: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 2,
    borderBottom: "0.3pt solid #E8E8E8",
  },

  emptyText: {
    fontSize: 7,
    color: "#777777",
    fontStyle: "italic",
    padding: 6,
  },

  // Cliente
  colRut: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colNombre: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colFecha: {
    width: "16%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colTelefono: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colDireccion: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colEmail: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colNacimiento: {
    width: "12%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  // Equipo
  colFamilia: {
    width: "18%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colTipo: {
    width: "22%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colMarca: {
    width: "13%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colModelo: {
    width: "16%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colSerie: {
    width: "13%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colServicio: {
    width: "14%",
    textAlign: "left",
    paddingHorizontal: 3,
  },

  colHora: {
    width: "4%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  // Diagnóstico
  colIndex: {
    width: "5%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  colItem: {
    width: "70%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  colCategory: {
    width: "25%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  // Presupuesto normal
  presuNumero: {
    width: "6%",
    textAlign: "center",
    paddingHorizontal: 2,
  },

  presuItemNormal: {
    width: "49%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  presuCategoriaNormal: {
    width: "20%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  presuPrecioNormal: {
    width: "25%",
    textAlign: "right",
    paddingHorizontal: 4,
  },

  // Presupuesto contractual
  presuItemContrato: {
    width: "39%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  presuCategoriaContrato: {
    width: "15%",
    textAlign: "left",
    paddingHorizontal: 4,
  },

  presuCondicion: {
    width: "25%",
    textAlign: "center",
    paddingHorizontal: 3,
  },

  presuPrecioContrato: {
    width: "15%",
    textAlign: "right",
    paddingHorizontal: 4,
  },

  contratoBox: {
    marginBottom: 9,
    padding: 7,
    backgroundColor: "#F7FAFC",
    borderLeft: "3pt solid #328AC4",
    borderRadius: 2,
  },

  contratoTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#328AC4",
    marginBottom: 3,
  },

  contratoText: {
    fontSize: 8,
    lineHeight: 1.4,
  },

  totalRow: {
    flexDirection: "row",
    paddingVertical: 4,
    paddingHorizontal: 6,
    borderTop: "0.5pt solid #D5DCE3",
  },

  totalLabel: {
    width: "75%",
    textAlign: "right",
    fontWeight: "bold",
    paddingRight: 8,
  },

  totalValue: {
    width: "25%",
    textAlign: "right",
    fontWeight: "bold",
    paddingRight: 2,
  },

  totalPagarRow: {
    flexDirection: "row",
    paddingVertical: 6,
    paddingHorizontal: 6,
    backgroundColor: "#EEF3F7",
    borderTop: "0.7pt solid #D5DCE3",
  },

  totalPagarLabel: {
    width: "75%",
    textAlign: "right",
    fontWeight: "bold",
    fontSize: 9,
    paddingRight: 8,
    color: "#328AC4",
  },

  totalPagarValue: {
    width: "25%",
    textAlign: "right",
    fontWeight: "bold",
    fontSize: 9,
    paddingRight: 2,
    color: "#328AC4",
  },

  observationSection: {
    marginTop: 4,
    padding: 6,
    border: "0.8pt solid #D5DCE3",
    borderRadius: 3,
    backgroundColor: "#FAFAFA",
  },

  observationTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#328AC4",
    marginBottom: 5,
  },

  observationText: {
    fontSize: 8,
    lineHeight: 1.5,
    textAlign: "justify",
  },

  conditionsSection: {
    marginTop: 8,
    padding: 7,
    backgroundColor: "#F7FAFC",
    borderLeft: "3pt solid #328AC4",
    borderRadius: 2,
  },

  conditionsTitle: {
    fontSize: 8,
    fontWeight: "bold",
    color: "#328AC4",
    marginBottom: 4,
  },

  conditionText: {
    fontSize: 7,
    lineHeight: 1.4,
    marginBottom: 3,
  },

  signatureSection: {
    marginTop: 12,
    flexDirection: "row",
    justifyContent: "flex-end",
  },

  signatureBox: {
    width: 190,
    alignItems: "center",
  },

  signatureLine: {
    width: 160,
    borderTop: "0.8pt solid #555555",
    marginBottom: 5,
  },

  signatureName: {
    fontSize: 9,
    fontWeight: "bold",
    textAlign: "center",
  },

  signatureRole: {
    fontSize: 7,
    marginTop: 2,
    textAlign: "center",
  },

  signatureArea: {
    fontSize: 7,
    color: "#666666",
    marginTop: 1,
    textAlign: "center",
  },

  footer: {
    position: "absolute",
    bottom: 14,
    left: 20,
    right: 20,
    flexDirection: "row",
    justifyContent: "space-between",
    fontSize: 6.5,
    color: "#777777",
    borderTop: "0.5pt solid #DDDDDD",
    paddingTop: 4,
  },

  footerContact: {
    width: "80%",
  },

  footerPage: {
    width: "20%",
    textAlign: "right",
  },
});

const PresuPDF = ({
  cabecera = [],
  falla = [],
  presu = [],
  total = 0,
  obs = "",
  usuario = [],
  empresa = "",
}) => {
  const ingreso = cabecera?.[0] || {};

  // Mantiene exactamente la regla contractual actual.
  const esCorrectivaContrato =
    ingreso?.origen_ingreso === "TRASPASO_ST_INTERNO" &&
    ingreso?.servicio === "PRESUPUESTO";

  const itemsValorizados = presu.filter(
    (item) =>
      item.categoria === "SERVICIO" ||
      item.categoria === "REPUESTO"
  );

  const totalReal = itemsValorizados.reduce(
    (acc, item) => acc + Number(item.price ?? 0),
    0
  );

  // En correctiva contractual sólo los servicios están cubiertos.
  const totalCubiertoContrato = esCorrectivaContrato
    ? itemsValorizados
        .filter((item) => item.categoria === "SERVICIO")
        .reduce(
          (acc, item) => acc + Number(item.price ?? 0),
          0
        )
    : 0;

  // En correctiva contractual el cliente paga sólo los repuestos.
  const totalPagar = esCorrectivaContrato
    ? itemsValorizados
        .filter((item) => item.categoria === "REPUESTO")
        .reduce(
          (acc, item) => acc + Number(item.price ?? 0),
          0
        )
    : totalReal || Number(total ?? 0);

  const tecnico = usuario?.[0];

  const nombreUsuario = tecnico
    ? `${tecnico.nombre || ""} ${tecnico.apellido || ""}`.trim()
    : "Técnico no informado";

  const numeroOrden = ingreso?.folio || "";

  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        {/* Logo */}
        {empresa && (
          <View style={styles.logoContainer}>
            <Image
              src={`../../${empresa}.png`}
              style={styles.logo}
            />
          </View>
        )}

        {/* Título */}
        <View style={styles.titleContainer}>
          <Text style={styles.titleText}>
            Presupuesto
          </Text>

          {numeroOrden && (
            <Text style={styles.orderText}>
              Orden de servicio N° {numeroOrden}
            </Text>
          )}
        </View>

        {/* Aviso contrato */}
        {esCorrectivaContrato && (
          <View style={styles.contratoBox}>
            <Text style={styles.contratoTitle}>
              ATENCIÓN CORRECTIVA CUBIERTA POR CONTRATO
            </Text>

            <Text style={styles.contratoText}>
              Los servicios técnicos se encuentran cubiertos por
              el contrato de mantención. El monto a pagar
              corresponde únicamente a los repuestos utilizados.
            </Text>
          </View>
        )}

        {/* Cliente */}
        <View style={styles.sectionTitle}>
          <Text style={styles.subTitle}>
            Información del cliente
          </Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.colRut}>RUT</Text>
            <Text style={styles.colNombre}>Nombre</Text>
            <Text style={styles.colFecha}>Fecha</Text>
            <Text style={styles.colTelefono}>Teléfono</Text>
            <Text style={styles.colDireccion}>Dirección</Text>
            <Text style={styles.colEmail}>Email</Text>
            <Text style={styles.colNacimiento}>F. Nac.</Text>
          </View>

          {cabecera.length > 0 ? (
            cabecera.map((p, i) => (
              <View
                style={styles.tableRow}
                key={p.id || i}
              >
                <Text style={styles.colRut}>
                  {p.rut || ""}
                </Text>

                <Text style={styles.colNombre}>
                  {p.entidad || ""}
                </Text>

                <Text style={styles.colFecha}>
                  {formatearFecha(p.date)}
                </Text>

                <Text style={styles.colTelefono}>
                  {p.telefono || ""}
                </Text>

                <Text style={styles.colDireccion}>
                  {p.direccion || ""}
                </Text>

                <Text style={styles.colEmail}>
                  {p.correo || ""}
                </Text>

                <Text style={styles.colNacimiento}>
                  {p.fnaci
                    ? formatearFecha(p.fnaci, false)
                    : "------"}
                </Text>
              </View>
            ))
          ) : (
            <Text style={styles.emptyText}>
              No se encontró información del cliente.
            </Text>
          )}
        </View>

        {/* Equipo */}
        <View style={styles.sectionTitle}>
          <Text style={styles.subTitle}>
            Información del equipo
          </Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.colFamilia}>Familia</Text>
            <Text style={styles.colTipo}>Tipo</Text>
            <Text style={styles.colMarca}>Marca</Text>
            <Text style={styles.colModelo}>Modelo</Text>
            <Text style={styles.colSerie}>Serie</Text>
            <Text style={styles.colServicio}>Servicio</Text>
            <Text style={styles.colHora}>Hora</Text>
          </View>

          {cabecera.length > 0 ? (
            cabecera.map((e, i) => (
              <View
                style={styles.tableRow}
                key={`equipo-${e.id || i}`}
              >
                <Text style={styles.colFamilia}>
                  {e.familia || ""}
                </Text>

                <Text style={styles.colTipo}>
                  {e.tipo || ""}
                </Text>

                <Text style={styles.colMarca}>
                  {e.marca || ""}
                </Text>

                <Text style={styles.colModelo}>
                  {e.modelo || ""}
                </Text>

                <Text style={styles.colSerie}>
                  {e.serie || ""}
                </Text>

                <Text style={styles.colServicio}>
                  {e.servicio || ""}
                </Text>

                <Text style={styles.colHora}>
                  {e.horamaquina ?? ""}
                </Text>
              </View>
            ))
          ) : (
            <Text style={styles.emptyText}>
              No se encontró información del equipo.
            </Text>
          )}
        </View>

        {/* Diagnóstico */}
        {falla?.length > 0 && (
          <>
            <View style={styles.sectionTitle}>
              <Text style={styles.subTitle}>
                Diagnóstico y falla
              </Text>
            </View>

            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={styles.colIndex}>N°</Text>
                <Text style={styles.colItem}>
                  Descripción
                </Text>
                <Text style={styles.colCategory}>
                  Categoría
                </Text>
              </View>

              {falla.map((item, i) => (
                <View
                  style={styles.tableRow}
                  key={item.item_id || item.id || i}
                >
                  <Text style={styles.colIndex}>
                    {i + 1}
                  </Text>

                  <Text style={styles.colItem}>
                    {item.item || "Sin descripción"}
                  </Text>

                  <Text style={styles.colCategory}>
                    {item.categoria || ""}
                  </Text>
                </View>
              ))}
            </View>
          </>
        )}

        {/* Presupuesto */}
        <View style={styles.sectionTitle}>
          <Text style={styles.subTitle}>
            Presupuesto
          </Text>
        </View>

        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={styles.presuNumero}>N°</Text>

            <Text
              style={
                esCorrectivaContrato
                  ? styles.presuItemContrato
                  : styles.presuItemNormal
              }
            >
              Ítem
            </Text>

            <Text
              style={
                esCorrectivaContrato
                  ? styles.presuCategoriaContrato
                  : styles.presuCategoriaNormal
              }
            >
              Categoría
            </Text>

            {esCorrectivaContrato && (
              <Text style={styles.presuCondicion}>
                Condición
              </Text>
            )}

            <Text
              style={
                esCorrectivaContrato
                  ? styles.presuPrecioContrato
                  : styles.presuPrecioNormal
              }
            >
              Precio
            </Text>
          </View>

          {itemsValorizados.length > 0 ? (
            itemsValorizados.map((item, i) => (
              <View
                style={styles.tableRow}
                key={item.item_id || item.id || i}
              >
                <Text style={styles.presuNumero}>
                  {i + 1}
                </Text>

                <Text
                  style={
                    esCorrectivaContrato
                      ? styles.presuItemContrato
                      : styles.presuItemNormal
                  }
                >
                  {item.item || ""}
                </Text>

                <Text
                  style={
                    esCorrectivaContrato
                      ? styles.presuCategoriaContrato
                      : styles.presuCategoriaNormal
                  }
                >
                  {item.categoria || ""}
                </Text>

                {esCorrectivaContrato && (
                  <Text
                    style={[
                      styles.presuCondicion,
                      {
                        fontWeight: "bold",
                        color:
                          item.categoria === "SERVICIO"
                            ? "#008080"
                            : "#d2691e",
                      },
                    ]}
                  >
                    {item.categoria === "SERVICIO"
                      ? "CUBIERTO POR CONTRATO"
                      : "A PAGAR"}
                  </Text>
                )}

                <Text
                  style={
                    esCorrectivaContrato
                      ? styles.presuPrecioContrato
                      : styles.presuPrecioNormal
                  }
                >
                  {formatoDinero(item.price)}
                </Text>
              </View>
            ))
          ) : (
            <Text style={styles.emptyText}>
              No se registraron servicios o repuestos.
            </Text>
          )}

          {/* Totales */}
          {esCorrectivaContrato ? (
            <>
              <View style={styles.totalRow}>
                <Text style={styles.totalLabel}>
                  Valor total servicios y repuestos
                </Text>

                <Text style={styles.totalValue}>
                  {formatoDinero(totalReal)}
                </Text>
              </View>

              <View style={styles.totalRow}>
                <Text style={styles.totalLabel}>
                  Servicios cubiertos por contrato
                </Text>

                <Text style={styles.totalValue}>
                  -{formatoDinero(totalCubiertoContrato)}
                </Text>
              </View>

              <View style={styles.totalPagarRow}>
                <Text style={styles.totalPagarLabel}>
                  TOTAL A PAGAR
                </Text>

                <Text style={styles.totalPagarValue}>
                  {formatoDinero(totalPagar)}
                </Text>
              </View>
            </>
          ) : (
            <View style={styles.totalPagarRow}>
              <Text style={styles.totalPagarLabel}>
                TOTAL
              </Text>

              <Text style={styles.totalPagarValue}>
                {formatoDinero(totalPagar)}
              </Text>
            </View>
          )}
        </View>

        {/* Observaciones */}
        <View style={styles.observationSection}>
          <Text style={styles.observationTitle}>
            Observaciones
          </Text>

          <Text style={styles.observationText}>
            {obs?.trim() ||
              "No se registraron observaciones adicionales."}
          </Text>
        </View>

        {/* Condiciones */}
        <View style={styles.conditionsSection} wrap={false}>
          <Text style={styles.conditionsTitle}>
            Condiciones
          </Text>

          <Text style={styles.conditionText}>
            • El presente presupuesto tiene una vigencia de 30
            días corridos desde su emisión.
          </Text>

          {esCorrectivaContrato ? (
            <>
              <Text style={styles.conditionText}>
                • Los servicios técnicos incluidos en este
                presupuesto se encuentran cubiertos por el
                contrato de mantención vigente.
              </Text>

              <Text style={styles.conditionText}>
                • El monto TOTAL A PAGAR corresponde
                exclusivamente a los repuestos indicados en el
                presente presupuesto.
              </Text>
            </>
          ) : (
            <Text style={styles.conditionText}>
              • En caso de NO ACEPTACIÓN, se aplicará un cargo
              mínimo de $30.000 IVA incluido por concepto de
              diagnóstico, pagadero al momento del retiro del
              equipo.
            </Text>
          )}

          <Text style={styles.conditionText}>
            • Si el equipo no es retirado dentro de 60 días
            corridos la empresa dispondrá de él para desecho,
            sin responsabilidad posterior.
          </Text>
        </View>

        {/* Firma */}
        <View style={{ flexGrow: 1 }} />

        <View
          style={styles.signatureSection}
          wrap={false}
        >
          <View
            style={styles.signatureBox}
            wrap={false}
          >
            <View style={styles.signatureLine} />

            <Text style={styles.signatureName}>
              {nombreUsuario.toUpperCase()}
            </Text>

            <Text style={styles.signatureRole}>
              Técnico responsable
            </Text>

            <Text style={styles.signatureArea}>
              Servicio Técnico
            </Text>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer} fixed>
          <Text style={styles.footerContact}>
            soporte@dormirbien.cl | General Parra #674 Oficina H,
            Providencia | +56 9 7632 1481 / +56 9 5423 4538
          </Text>

          <Text
            style={styles.footerPage}
            render={({ pageNumber, totalPages }) =>
              `Página ${pageNumber} de ${totalPages}`
            }
          />
        </View>
      </Page>
    </Document>
  );
};

const formatearFecha = (fecha, incluirHora = true) => {
  if (!fecha) return "------";

  try {
    let fechaConvertida;

    if (typeof fecha?.toDate === "function") {
      fechaConvertida = fecha.toDate();
    } else if (fecha instanceof Date) {
      fechaConvertida = fecha;
    } else {
      fechaConvertida = new Date(fecha);
    }

    if (Number.isNaN(fechaConvertida.getTime())) {
      return "------";
    }

    return moment(fechaConvertida).format(
      incluirHora
        ? "DD/MM/YYYY HH:mm"
        : "DD/MM/YYYY"
    );
  } catch (error) {
    console.error("Error al formatear fecha:", error);
    return "------";
  }
};

const formatoDinero = (valor) =>
  `$${Number(valor ?? 0).toLocaleString("es-CL")}.-`;

export default PresuPDF;